module.exports = __webpack_public_path__ + "static/media/mercedes.272749ed.jpg";